import React, { useEffect, useState } from "react";
import styles from "./GameSchule.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchGames } from "../../services/apiEndpoints";
import { API_BASE_URL } from "../../services/apiHandler";

const getImageUrl = (imgUrl) => `${API_BASE_URL}/${imgUrl}`;

const GameSchedule = () => {
  const navigate = useNavigate();
  const [gameSchedule, setGameSchedule] = useState([]);

  const fetchGameSchedule = async (sport_row_id) => {
    try {
      const gameScheduleResp = await fetchGames(sport_row_id);
      console.log("Games Schedule ", gameScheduleResp.data);

      setGameSchedule(gameScheduleResp.data);
    } catch (error) {
      console.log("your error is", error);
    }
  };

  useEffect(() => {
    fetchGameSchedule(sport_row_id);
  }, []);

  const { sport_row_id } = useParams();

  console.log("new data is ", sport_row_id);

  const [showModal, setShowModal] = useState(false);

  const random = () => {
    const backgroundColor = ["#98DC7F", "#C36F91", "#7ED9C3"];
    const randomColors =
      backgroundColor[Math.floor(Math.random() * backgroundColor.length + 0)];
    return randomColors;
  };

  return (
    <div className={styles.cardsContainer}>
      <div className={styles.closePage} onClick={() => navigate("/schedule")}>
        ←
      </div>
      {gameSchedule &&
        gameSchedule.map((game, index) => (
          <React.Fragment key={index}>
            {index === 0 && (
              <h2 className={styles.gameName}>{game.sport_name}</h2>
            )}
            <div
              className={styles.card}
              key={index}
              style={{ backgroundColor: random() }}
            >
              <p className={styles.title}>{game.game_title}</p>

              {game.teams.teams.length <= 2 && (
                <>
                  <div className={styles.teamsContainer}>
                    {game?.teams.teams.map((team, index) => (
                      <React.Fragment key={index}>
                        <div className={styles.team}>
                          <img
                            src={getImageUrl(team.team_img)}
                            alt={team.team_name}
                            className={styles.logo}
                          />
                          <p className={styles.team_name}>{team.team_name}</p>
                        </div>

                        {index === 0 && game.teams.teams.length > 1 && (
                          <span className={styles.vs}>VS</span>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </>
              )}

              {/* <div className={styles.teamsContainer}>
                {game?.teams.teams.slice(0, 2).map((team, index) => (
                  <React.Fragment key={index}>
                    <div className={styles.team}>
                      <img
                        src={getImageUrl(team.team_img)}
                        alt={team.team_name}
                        className={styles.logo}
                      />
                      <p className={styles.team_name}>{team.team_name}</p>
                    </div>
                    {index === 0 && game.teams.teams.length > 1 && (
                      <span className={styles.vs}>VS</span>
                    )}
                  </React.Fragment>
                ))}
              </div> */}

              {game.teams.teams.length > 2 && (
                <button
                  className={styles.seeMoreButton}
                  onClick={() => setShowModal(true)}
                >
                  See More
                </button>
              )}
              <p className={styles.dateTime}>
                {game.game_date} - {game.game_time}
              </p>
              {showModal && (
                <div className={styles.modal}>
                  <div className={styles.modalContent}>
                    <button
                      className={styles.closeButton}
                      onClick={() => setShowModal(false)}
                    >
                     X
                    </button>
                    <h2>Teams</h2>
                    <div className={styles.modalTeams}>
                      {game.teams.teams.map((team, index) => (
                        <React.Fragment key={index}>
                          <div className={styles.modalTeam}>
                            <img
                              src={getImageUrl(team.team_img)}
                              alt={team.team_name}
                              className={styles.modalLogo}
                            />
                            <p className={styles.modalTeamName}>
                              {team.team_name}
                            </p>
                          </div>
                          {index < game.teams.teams.length - 1 && (
                            <span className={styles.vs}>VS</span>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </React.Fragment>
        ))}
    </div>
  );
};

export default GameSchedule;
